export default {
  body: {
    color: "#101010",
    backgroundColor: "#fff"
  },
  button: {
    backgroundColor: "#b9d232",
    color: "#000"
  },
  label: {
    color: "#101010"
  },
  input: {
    color: "#101010"
  },
  infoBox: {
    backgroundColor: "#f8faea"
  }
}
